import { format, isPast, differenceInDays } from "date-fns"
import { ptBR } from "date-fns/locale"

export const getEventStatus = (dateLimit: string | null) => {
  if (!dateLimit) return { expired: false, label: "Acesso Liberado", isUrgent: false }

  const d = new Date(dateLimit)
  const expired = isPast(d)
  const days = differenceInDays(d, new Date())

  return {
    expired,
    days,
    isUrgent: !expired && days <= 7,
    label: expired ? "Expirado" : days === 0 ? "Expira hoje" : `${days} dias restantes`,
    formatted: format(d, "dd/MM/yyyy 'às' HH:mm", { locale: ptBR }),
  }
}
